var _path, _path2, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChainListIcon5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 112,
    viewBox: "0 0 99 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7157 8.25213C36.6208 -5.22951 64.8631 3.26477 82.7966 27.2247C100.73 51.184 101.564 81.5361 84.6588 95.0181C67.7538 108.499 39.5115 100.005 21.5779 76.0456C3.6444 52.0858 2.81055 21.7337 19.7157 8.25213Z",
    fill: "#DAF727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5295 15.8584C22.2996 8.86423 33.9492 7.62504 45.5959 11.1279C57.2409 14.6303 68.9559 22.8847 78.0344 35.0137C87.1132 47.1434 91.8865 60.9177 92.2297 73.4111C92.5728 85.8999 88.4828 97.2002 79.72 104.188C70.9499 111.182 59.3003 112.421 47.6536 108.918C36.0086 105.416 24.2936 97.1622 15.2151 85.0332C6.13624 72.9035 1.36296 59.1283 1.01978 46.6348C0.676836 34.1462 4.76687 22.8464 13.5295 15.8584Z",
    fill: "#5235E8",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 41,
    width: 50,
    height: 39
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 33,
    transform: "translate(22.4887 47.1697) rotate(-7.71467)",
    fill: "url(#pattern0_1_120)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.4887,
    y: 47.1697,
    width: 45,
    height: 33,
    transform: "rotate(-7.71467 22.4887 47.1697)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_120",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_120",
    transform: "scale(0.0222222 0.030303)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_120",
    width: 45,
    height: 33,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainListIcon5);
export default __webpack_public_path__ + "static/media/chain-list-icon-5.b2980913e597b7a70da6500c61c36e52.svg";
export { ForwardRef as ReactComponent };